import { UserConfigModel } from './Types';

export default (userConfig: Record<string, any>): UserConfigModel => {
  const {
    enableFastPayments = false,
    sacOnboard = 'default',
    isRentGuaranteeEnabled = false,
    landlordBirthDayMax = 0,
    landlordBirthDayMin = 0,
  } = userConfig;
  return {
    enableFastPayments: Boolean(enableFastPayments),
    sacOnboard: sacOnboard && String(sacOnboard),
    isRentGuaranteeEnabled,
    landlordBirthDayMax,
    landlordBirthDayMin,
  };
};
